import { useMutation } from "@tanstack/react-query";
import { getIntensityEmbedUrl, IntensityEmbedUrlResponse } from "api";

// TODO: TEMPORAL - REMOVE when Intensity external link functionality is removed
// Temporary hook to get Intensity embed URL - uses mutation to fetch only on click
export const useGetIntensityEmbedUrl = () =>
  useMutation<IntensityEmbedUrlResponse, Error, void>({
    mutationFn: () => getIntensityEmbedUrl(),
  });

